export const getIsDevelopment = (config?: any): boolean => {
  const apiUrl = config?.API_URL || process.env.NUXT_API_URL
  return (apiUrl !== 'https://onthatass.com/api') || import.meta.dev
}
